var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1311 7.75001H13.8711V5.84001C13.8161 5.29001 14.2161 4.80001 14.7661 4.74501C14.8011 4.74101 14.8361 4.74001 14.8711 4.74001H17.8711V0.740005H13.5411C9.61109 0.740005 8.87109 3.74001 8.87109 5.60001V7.75001H5.87109V11.75H8.87109V23.25H13.8711V11.75H17.7211L18.1311 7.75001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b479c5085b0c556ab6937d9d7335fc95.svg";
export { ForwardRef as ReactComponent };